export const formatValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};

export const getSubTestDirectories = (testDirectories, test_ids) => {
  let subTests = [];
  if (Array.isArray(test_ids)) {
    test_ids.forEach((id) => {
      // console.log("entered to each");
      testDirectories.forEach((test) => {
        if (test.id === id) {
          subTests.push(test);
        }
      });
    });
  }
  return subTests;
};
